'use strict'; // TODO: remove, semver-major

module.exports = require('es-object-atoms/isObject');